export default __webpack_public_path__ + "static/media/oscer-pres-sensory-disturbance.c7ddb179.svg";